import { Component, Input, OnInit, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DelfiComponentsLibraryModule } from '@mare-common/ngx-delfi-components';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { ProductService, ProductsRequestParams } from '../services/product.service';
import { CompanyInterfaceExtended, UserCompanyService } from '../services/userCompany.service';
import { Subject, takeUntil } from 'rxjs';
import { CarouselModule } from '@marcreichel/angular-carousel';
import { ProductRelatedItem, ProductRelatedItemComponent } from './components/product-related-item/product-related-item.component';
import { Product } from '@mare-common/ngx-delfi-components/lib/products-list/product.interface';
import { InnovationProduct } from '@mare-common/ngx-delfi-components/lib/common-service/models/innovation.model';
import { ProductsOverviewComponent } from '../products-overview/products-overview.component';
import { MareLoaderModule } from '@mare-common/ngx-mare-loader';
import { NgxTypedWriterModule } from 'ngx-typed-writer';
import { ProductRelatedSuggestionComponent, ProductSuggestionGroup } from './components/product-related-suggestion/product-related-suggestion.component';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { PromoProductComponent } from '../promo/promo-product/promo-product.component';
import { ProductRelatedCardComponent } from './components/product-related-card/product-related-card.component';


@Component({
  selector: 'products-related',
  standalone: true,
  imports: [
    CommonModule,
    DelfiComponentsLibraryModule,
    TranslateModule,
    SharedModule,
    CarouselModule,
    ProductRelatedItemComponent,
    ProductRelatedSuggestionComponent,
    ProductsOverviewComponent,
    MareLoaderModule,
    NgxTypedWriterModule,
    ScrollingModule,
    PromoProductComponent,
    ProductRelatedCardComponent
  ],
  templateUrl: './products-related.component.html',
  styleUrls: ['./products-related.component.scss'],
  animations: [
    trigger('slideInUp', [
      state('enter', style({ transform: 'translateY(0)' })),
      state('leave', style({ transform: 'translateY(100%)' })),
      transition('enter <=> leave', [animate('700ms ease-in-out')]),
      
      
    ])
  ]
})
export class ProductsRelatedComponent implements OnInit{
  
  @Input() company!: CompanyInterfaceExtended;

  @Input() layout: 'carousel' | 'promo-carousel' | 'grid' | 'accordion' | 'list' | 'cards' | 'suggestions' = 'suggestions';
  /** carousel configuration available @ https://marcreichel.dev/docs/angular-carousel */

  @Input() productSkus?: string | Array<string>;
  @Input() productsIds?: Array<string>;
  @Input() productsTags?: string | Array<string>;

  @Input() hideProductsOverview = false;

  effect_complete: any;

  playCarousel:boolean = false

  suggestionsGroups$ = signal<Array<ProductSuggestionGroup> | null>(null);

  productSuggested$ = signal<Array<any> >([]);
  dynamicOffer: any = [];
  
  findingRelatedProducts$ = signal<boolean>(false);

  
  suggestedGroups!: any[];

  
  products!: Array<InnovationProduct>;
  productsRelated!: Array<any>;

  private unsubscribe$ = new Subject<void>();
  isInView: boolean = false;
  show_suggestions: boolean = false;

  constructor(private productService: ProductService,
    private userCompanyService: UserCompanyService
  ) { 
  }
  ngOnInit(): void {
    let params: ProductsRequestParams = {}
    if (this.productsIds) {
      if (Array.isArray(this.productsIds)) {
        params.ids = this.productsIds.join(',');
      } else {
        params.ids = this.productsIds;
      }
    }
    else if (this.productSkus) {
      if (Array.isArray(this.productSkus)) {
        params.skus = this.productSkus.join(',');
      } else {
        params.skus = this.productSkus;
      }
    }
    else if (this.productsTags) {
      if (Array.isArray(this.productsTags)) {
        params.tags = this.productsTags.join(',');
      } else {
        params.tags = this.productsTags;
      }
    }
    
    this.productService.getProductsParams(params).then((products: any) => {
      this.products = products;
      console.log(products);
      this.findingRelatedProducts$.set(true);
      if(this.layout === 'suggestions') {
         this.initSuggestions(products).then((res: any) => {
        this.productSuggested$.set(res);
        }).catch((err: any) => {
          console.log(err);
          this.productSuggested$.set([]);
        }).finally(() => {
          this.findingRelatedProducts$.set(false);
        })
      } else {
        this.findingRelatedProducts$.set(false);
        this.productSuggested$.set(products);
      }
     


    })
  }

  /**
   * Initializes suggestions based on the user's company information and provided products.
   *
   * @param {Array<Product>} allproducts - Array of all products
   * @return {Promise<any>} A promise that resolves with the dynamic offer
   */
  initSuggestions(allproducts: Array<Product>): Promise<any> {
    return new Promise((resolve, reject) => {
      
   
    this.userCompanyService.userCompany$.pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
      if (res) {
        this.company = res.company;
        // console.log(this.suggestionsGroups$());
        let suggestedProducts = this.company?.delfi_offers ? JSON.parse(this.company.delfi_offers) : null;
       
        
        if (!suggestedProducts) {
          reject('no delfi offers found');
         
          // this.productSuggested$.set(null);
          return 
        }
        console.log(suggestedProducts);
        
        
        let product_solutions!: Array<Product>;
        suggestedProducts.what_as.forEach((element: any) => {
          /** recuperiamo gli sku dei prodotti suggeriti */
          product_solutions = [];
          let solutionsSkus = element.suggestion.reduce((acc: string[], curr: any) => {
            acc.push(curr.sku);
            return acc;
          }, []);
         

          /** 
           * filtriamo i prodotti in base agli sku suggeriti
           *  */
          let products_suggested = allproducts?.length > 0 ? allproducts.filter((p: any) => solutionsSkus.includes(p.sku)) : [];
          products_suggested = JSON.parse(JSON.stringify(products_suggested));
          
          /** 
           * sostiuiamo le descrizioni dei prodotti con la spiegazione della soluzione
           *  */
          if (products_suggested && products_suggested.length > 0) {
            products_suggested.forEach((el: any) => {
              let solution = element.suggestion.find((s: any) => s.sku == el.sku);
             
              // let product: any = allproducts.products.find((p: any) => p.sku == el.sku);
              if (el) {
                //get a trimmed verion of el.solution text at 124 chars
                // el.short_description = solution?.solution?.length > 500 ? solution.solution.substring(0, 500) + '...' : solution.solution ;
                el.short_description = solution.solution;

                // el.description += '<br/><p class="mt--4"><b>PERCH&Egrave; TI SERVE</b></p>' + solution.html_solution;
                el.read_more_label = 'Scopri di più';
              }
              product_solutions.push(el);

            })
          }

          /**  
           * costruiamo il singolo blocco di offerta indicante problema, descrizione e i prodotti suggeriti
           *  */ 
          let offer = {
            problem_name: element.problem_name,
            problem_description: element.problem_description,
            suggestion: product_solutions
          }

          this.dynamicOffer.push(offer);
        });
        resolve(this.dynamicOffer);
      }
    });

    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  reveal(event: any) {
    if (event) {
      this.isInView = true
    }
  }
  setSuggestions() {
    let timoutu = setTimeout(() => {
      
      this.show_suggestions = true;
      clearTimeout(timoutu);
    }, 1000);
  }

  currentIndex: number = 0;

  showNext(event: any) {
    if (this.currentIndex <= event) {
      this.currentIndex++;
    }
  }

}
